export type FileJobKind = 'document' | 'image'
export type FileJobStage =
  | 'preparing'
  | 'uploading'
  | 'processing'
  | 'extracting'
  | 'translating'
  | 'finalizing'
  | 'done'
  | 'error'

export interface FileJobState {
  kind: FileJobKind
  filename: string
  stage: FileJobStage
  startedAt: number
}

export type FileJobEvent =
  | { type: 'uploading' }
  | { type: 'processing' }
  | { type: 'extracting' }
  | { type: 'translating' }
  | { type: 'finalizing' }
  | { type: 'done' }
  | { type: 'error' }

export function createFileJob(kind: FileJobKind, filename: string): FileJobState {
  return {
    kind,
    filename,
    stage: 'preparing',
    startedAt: Date.now(),
  }
}

export function advanceFileJob(state: FileJobState, event: FileJobEvent): FileJobState {
  return { ...state, stage: event.type }
}

export function stageCopy(stage: FileJobStage): { title: string; detail: string } {
  switch (stage) {
    case 'preparing':
      return { title: 'Preparing your file', detail: 'Checking the file before it is sent securely.' }
    case 'uploading':
      return { title: 'Uploading securely', detail: 'Sending your file to baba for this translation.' }
    case 'processing':
      return { title: 'Reading your document', detail: 'Preparing the file and mapping its structure.' }
    case 'extracting':
      return { title: 'Reading your image', detail: 'Finding Hebrew text and preserving its layout.' }
    case 'translating':
      return { title: 'Translating the content', detail: 'Writing a clear translation while keeping the original meaning.' }
    case 'finalizing':
      return { title: 'Finishing up', detail: 'Organizing the translation and key points.' }
    case 'done':
      return { title: 'Translation ready', detail: 'Your translated content is ready.' }
    case 'error':
      return { title: 'Translation stopped', detail: 'The file could not be completed.' }
  }
}
